export const appSettings = {
  name: "ORTO - פירות וירקות פרימיום | משלוח טרי עד הבית בכל הארץ",
  description:
    "Orto הוקמה על מנת לספק ללקוח את הפירות והירקות הטובים ביותר, במחירים האיכותיים ביותר ובשירות הטוב ביותר. כנסו לאתר שלנו ותראו בעצמכם!",
  appInfoMail: "cs@orto.co.il",
  address: "Israel",
  phone: "03-5091625",
  websiteUrl: "https://orto.co.il/",
  canonical: "https://orto.co.il/",
  author: {
    name: "Orto",
    facebookUrl: "https://www.facebook.com/profile.php?id=61551068551659",
    instagramUrl: "https://www.instagram.com/orto_il/",
  },
  developer: {
    name: "CODIT Software Solutions Ltd.",
    websiteUrl: "https://www.codit.co.il/",
    address: "Baqa al-Gharbiyye",
  },
  logo: {
    url: require("../../../public/assets/logo/logo2.png"),
    alt: "Orto",
    href: "/",
    width: 95,
    height: 30,
  },
  defaultLanguage: "he",
  currencyCode: "ILS",
  VendorCode: "ORTO",
  VendorKey: "orto_preferences",
  version: "1.0.0",
};
